// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SettingsIcon } from '@moia-dev/pace-icons'
import { TripApiConfigurationAreaRoutes } from './TripApiConfigurationAreaRoutes'

export const TripApiConfigurationAreaNavigationIcon = SettingsIcon

export const TripApiConfigurationAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={TripApiConfigurationAreaRoutes.route}
      Icon={SettingsIcon}
    />
  )
}
